import { IconButton, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../routes/RouteConstants';
import { useTenant } from '../../../contexts/TenantContext';
import { gradientTextSx, tint } from '../../../utils/textStyles';
import { formatPrice } from '../../../utils/priceUtils';
import { isDarkTheme } from '../../../utils/themeTraits';
import ChosenProviderChip from '../../provider/components/ChosenProviderChip';


/**
 * The booking page's header: a band across the top of the card with the way back to the
 * services and the one chosen (DECISIONS.md D31). It replaces the big "A választott
 * szolgáltatás" heading and its bordered box, so the calendar sits higher. On a tenant with several
 * providers it also names the one chosen, with the way back to the choice (docs/MULTI_PROVIDER.md).
 */
const ChosenSupplyBand = ({ supply }) => {
  const { displayConfig } = useTenant();
  const navigate = useNavigate();
  const isDark = isDarkTheme(displayConfig);
  const accent = displayConfig?.primaryColor;
  const textColor = displayConfig?.color;
  const quietColor = tint(textColor, 0.66);
  // The dark theme lights the band in its accent and the name in its own colour. On paper the
  // band stays paper and the name is ink (brownsbs, DECISIONS.md D31).
  const bandColor = isDark ? tint(accent, 0.14) : "transparent";
  const nameColor = isDark ? displayConfig?.selectedSupplyNameColor || textColor : textColor;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{ px: { xs: 2, sm: 3 }, py: 2, backgroundColor: bandColor }}
    >
      <IconButton
        aria-label="Vissza a szolgáltatásokhoz"
        onClick={() => navigate(Routes.SUPPLY)}
        sx={{
          flexShrink: 0,
          color: accent,
          border: `1px solid ${tint(accent, 0.45)}`,
          backgroundColor: tint(accent, 0.08),
          "&:hover": { backgroundColor: tint(accent, 0.18) },
        }}
      >
        <ArrowBackIcon fontSize="small" />
      </IconButton>

      <Stack minWidth={0}>
        <Typography fontSize={11.5} letterSpacing="0.08em" textTransform="uppercase" sx={{ color: quietColor }}>
          A választott szolgáltatás
        </Typography>
        <Typography
          fontSize={17}
          fontWeight={700}
          lineHeight={1.25}
          sx={gradientTextSx(displayConfig, nameColor)}
        >
          {supply?.name}
        </Typography>
        <Typography fontSize={13} sx={{ color: quietColor }}>
          {`${supply ? formatPrice(supply.price) : ''} · ${supply?.duration} perc`}
        </Typography>
        <ChosenProviderChip returnTo={Routes.BOOKING} sx={{ mt: 0.75 }} />
      </Stack>
    </Stack>
  );
};

export default ChosenSupplyBand;
